import { render, staticRenderFns } from "./changeData.vue?vue&type=template&id=5262d62a&scoped=true"
import script from "./changeData.vue?vue&type=script&lang=js"
export * from "./changeData.vue?vue&type=script&lang=js"
import style0 from "./changeData.vue?vue&type=style&index=0&id=5262d62a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5262d62a",
  null
  
)

export default component.exports